var n = {
  0: "Jan.",
  1: "Feb.",
  2: "March",
  3: "April",
  4: "May",
  5: "June",
  6: "July",
  7: "Aug.",
  8: "Sept.",
  9: "Oct.",
  10: "Nov.",
  11: "Dec."
};

function t(t) {
  return void 0 === t && (t = new Date()), n[t.getMonth()];
}

function r(n) {
  return void 0 === n && (n = new Date()), t(n) + " " + n.getDate() + ", " + n.getFullYear();
}

function i(n) {
  return null == n;
}

function e(n) {
  return "number" == typeof n && isFinite(n);
}

function o(n) {
  return e(n) && Math.floor(n) === n;
}

var u = ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];

function a(n) {
  if (i(n)) return "";
  var t = +n;
  return o(t) ? t <= 0 || t >= 10 ? n.toString() : u[t - 1] : n.toString();
}

function l(n) {
  void 0 === n && (n = new Date());
  var t,
      r,
      i = n.getHours(),
      e = n.getMinutes(),
      o = 0 === e;

  if (o) {
    if (0 === i) return "midnight";
    if (12 === i) return "noon";
  }

  return i < 12 ? (t = "a.m.", r = i > 0 ? i : 12) : (t = "p.m.", r = 12 === i ? i : i - 12), o ? r + " " + t : r + ":" + (e < 10 ? "0" + e : e) + " " + t;
}

function f(n) {
  if (i(n)) return "";
  var t = String(n);
  return "" + t.charAt(0).toUpperCase() + t.slice(1);
}

function v(n) {
  if (i(n)) return "";
  var t,
      r = +n;
  return e(r) ? ((t = r.toString().split("."))[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), t.join(".")) : n.toString();
}

var c = ["million", "billion", "trillion", "quadrillion", "quintillion", "sextillion", "septillion", "octillion", "nonillion", "decillion"];

function g(n) {
  if (i(n)) return "";
  var t = +n;
  if (!o(t)) return n.toString();
  if (t < 1e6) return n.toString();
  var r = Math.ceil(Math.log(t + 1) / Math.LN10) - 1,
      e = r - r % 3,
      u = t / Math.pow(10, e);
  return (u = Math.round(10 * u) / 10) + " " + c[Math.floor(e / 3) - 2];
}

var h = ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"],
    d = [11, 12, 13];

function s(n) {
  if (i(n)) return "";
  var t = +n;
  return o(t) ? d.indexOf(t % 100) > -1 ? t + h[0] : t + h[t % 10] : n.toString();
}

function p(n, t, r) {
  return void 0 === t && (t = "s"), void 0 === r && (r = ""), Array.isArray(n) ? 1 !== n.length ? t : r : 1 !== Number(n) ? t : r;
}

var M = " ",
    S = new RegExp(/\s+([^\s]*)\s*$/);

function m(n, t) {
  return void 0 === t && (t = M), i(n) ? "" : String(n).replace(S, t + "$1");
}

function y(n, t, r, e) {
  void 0 === t && (t = "yes"), void 0 === r && (r = "no"), void 0 === e && (e = "maybe");
  var o = arguments.length;
  return 2 === o ? n : (3 === o && (e = r), i(n) ? e : n ? t : r);
}

export { r as apdate, t as apmonth, a as apnumber, l as aptime, f as capfirst, v as intcomma, g as intword, s as ordinal, p as pluralize, m as widont, y as yesno };